import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

/** Defaults match production (skimbuster-micclo); override via `.env` for staging or forks. */
const defaultFirebaseConfig = {
  apiKey: 'AIzaSyBWoE0ggb5QSYsA1x1p-CuyMPya9cI_POM',
  authDomain: 'skimbuster-micclo.firebaseapp.com',
  projectId: 'skimbuster-micclo',
  storageBucket: 'skimbuster-micclo.firebasestorage.app',
  messagingSenderId: '160681021560',
  appId: '1:160681021560:android:695477434b194537ce9d8d',
} as const;

function envOr<T extends string>(key: `REACT_APP_${string}`, fallback: T): T {
  const v = process.env[key]?.trim();
  return (v || fallback) as T;
}

// Same Firebase project as skimbuster-mobile (skimbuster-micclo)
const firebaseConfig = {
  apiKey: envOr('REACT_APP_FIREBASE_API_KEY', defaultFirebaseConfig.apiKey),
  authDomain: envOr('REACT_APP_FIREBASE_AUTH_DOMAIN', defaultFirebaseConfig.authDomain),
  projectId: envOr('REACT_APP_FIREBASE_PROJECT_ID', defaultFirebaseConfig.projectId),
  storageBucket: envOr('REACT_APP_FIREBASE_STORAGE_BUCKET', defaultFirebaseConfig.storageBucket),
  messagingSenderId: envOr('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', defaultFirebaseConfig.messagingSenderId),
  appId: envOr('REACT_APP_FIREBASE_APP_ID', defaultFirebaseConfig.appId),
};

const app = initializeApp(firebaseConfig);

/** Secondary app: createUserWithEmailAndPassword on the default auth would sign the admin out and switch to the new user. */
const USER_CREATION_APP_NAME = 'SkimbusterPortalUserCreation';
let userCreationApp: FirebaseApp | undefined;

export function getUserCreationAuth(): Auth {
  if (!userCreationApp) {
    const existing = getApps().find((a) => a.name === USER_CREATION_APP_NAME);
    userCreationApp = existing ?? initializeApp(firebaseConfig, USER_CREATION_APP_NAME);
  }
  return getAuth(userCreationApp);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
